import {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector} from 'react-redux';
import { loginUser } from '../../redux/actions/authActions';


const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const { isAuthenticated } = useSelector((state) => state.auth);
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/index');
    }
  }, [isAuthenticated, navigate]);


  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const success = await dispatch(loginUser(username, password));
      if (success) {
        navigate('/index');
      } else {
        setError('Λάθος στοιχεία πρόσβασης');
      }
    } catch (error) {
      setError('Aποτυχία σύνδεσης');
    }
  };
  return (
    <Container maxWidth="xs">
      <Paper elevation={10} sx={{ marginTop: 8, padding: 2 }}>
        
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        </Box>
        
        <Typography component="h1" variant="p" sx={{ textAlign: "center" }}>
          IoT
        </Typography>
        <Typography component="h2" variant="p" sx={{ textAlign: "center" }}>
          Διαχείριση Αισθητήρων και Συσκευών
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            placeholder="Όνομα Χρήστη"
            fullWidth
            required
            autoFocus
            sx={{ mb: 2 }}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            placeholder="Κωδικός Πρόσβασης"
            fullWidth
            required
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}

          <Button type="submit" variant="contained" fullWidth sx={{ mt: 1 }}>
            Σύνδεση
          </Button>
        </Box>
        <Grid container justifyContent="space-between" sx={{ mt: 1 }}>
        </Grid>
      </Paper>
    </Container>
  );
};

export default LoginPage;
